module.exports = __webpack_public_path__ + "static/PFB__0009_Draft-66dbcb96bd8ba8d8a3d2821bd003294d.png";